module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNsptL////z+PudxOHC2uxHj8e20umRvN1gns7O4fDn8PhUl8upy+Xa6fSFtdpriMdtAAAAB3RSTlMAYL8AIM/vi50ITwAAAN1JREFUeF7t2EmuwyAURFHAdoreffa/1O9MrC8FZIFrYEXcBZzZQ6jEJ6lwIyW7I9F1/YCbDf0H6l+43as/oAGEhk5IUJJCgZISIPVrUIOC/qoGCpv5zrpyyJtkYyk0mXS2FHIm01QIzTlIsyCQoI0EeVRDi/vXhHpoxnUNuqpBdj7z41oDpbJvEmRsIEFmZEHucdBEgiIokHWoh3Z9tj7iRBrUXsizTYN3/Y/7aEUWNBdCWw7yhZDOQe9CCDHt7CiF4JaEE0MWItSgBrFGFtrswxqiaNMYc6w7YsyHf8/slrzxBmhZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f1ea.png
// module id = 593
// module chunks = 0